
import { get, set, remove } from 'local-storage';

import { ITokens, ITokenStore, TokenTypes } from './TokenStore';

/**
 * Stores tokens in memory locally
 */
export class LocalStorageTokenStore implements ITokenStore {
  environment?: string;

  constructor(private keyPrefix: string) {
  }

  updateTokens(tokens: ITokens) {
    for (const [tokenType, value] of Object.entries(tokens)) {
      if (value === undefined) {
        remove(this.keyString(tokenType));
      } else {
        set(this.keyString(tokenType), value);
      }
    }
  }

  set id(token) {
    this.updateTokens({ id: token });
  }

  set access(token) {
    this.updateTokens({ access: token });
  }

  set restricted(token) {
    this.updateTokens({ restricted: token });
  }

  set refresh(token) {
    this.updateTokens({ refresh: token });
  }

  get id() {
    return get<string|undefined>(this.keyString('id'));
  }

  get refresh() {
    return get<string|undefined>(this.keyString('refresh'));
  }

  get access() {
    return get<string|undefined>(this.keyString('access'));
  }

  get restricted() {
    return get<string|undefined>(this.keyString('restricted'));
  }

  keyString(tokenType: string): string {
    const { keyPrefix } = this;
    return `${keyPrefix}-${tokenType}`;
  }

  // TODO figure out how to remove the any here
  async clear(tokensToClear?: TokenTypes[]): Promise<any> {
    tokensToClear = tokensToClear || [TokenTypes.ID, TokenTypes.ACCESS, TokenTypes.REFRESH];

    for (const tokenType of tokensToClear) {
      remove(this.keyString(tokenType));
    }
  }
}